import { RegistrationUserAttributes } from "@domain/authentication/auth-service";
import { BaseExercise } from "@domain/exercise/exercise";
// ProgramId import removed - now using string type instead
import { RegisterQueryParams } from "@domain/register/register";



import { LeavingReason } from "@ui/pages/deletion-flow/leaving-reasons-page";
import { HomeTabNames } from "@ui/pages/home/components/patient-tabs";
import { TabSettings } from "@ui/pages/settings/settings-page";
import { ProgramListTabNames } from "@ui/pages/program/components/tabs";
import { getEnumValues } from "@utils/enum-utils";

export enum RoutesPath {
	Home = "/",
	Settings = "/settings",
	Register = "/register",
	RegisterPrivacyNotice = "/register/privacy-notice",
	RegisterTermsOfUse = "/register/terms-of-use",
	Login = "/login",
	Rejected = "/rejected",
	VipLoginRedirection = "/vip",
	VipLogin = "/vip/:veevaId",
	ForgotPassword = "/forgot-password",
	TermsOfUse = "/legal/terms-of-use",
	PrivacyNotice = "/legal/privacy-notice",
	PatientDetails = "/patient-details/:patientId",
	ProgramBuilder = "/program-builder/:patientId",
	ProgramList = "/programs",
	TemplateBuilder = "/new-program",
	ExerciseList = "/exercises",
	Learn = "/learn",
	LearnDocument = "/learn/:documentId",
	NotificationCenter = "/notifications",
	InviteYourPt = "/invite-your-physiotherapist",
	Debug = "/debug",
	DemoRequest = "/demo-request",
	LeavingReasons = "/leaving-reasons",
	AccountDeleted = "/account-deleted",
	ProfessionalInformation = "/professional-information",
	ThankYouSurvey = "/survey-thankyou",
	GetStarted = "/get-started",
}

export const routesPaths = getEnumValues(RoutesPath);

// The params that are present in the RoutesPath value
export type RouteParams = {
	[RoutesPath.PatientDetails]: { patientId: string };
	[RoutesPath.ProgramBuilder]: { patientId: string };
	[RoutesPath.VipLogin]: { veevaId: string };
	[RoutesPath.LearnDocument]: { documentId: string };
};

// The params that are present in the query part of the url
export type QueryParams = {
	[RoutesPath.Login]: { patientId?: string; ptId?: string; lang?: string };
	[RoutesPath.Home]: { patientId?: string; ptId?: string; active?: HomeTabNames };
	[RoutesPath.Register]: RegisterQueryParams;
	[RoutesPath.RegisterTermsOfUse]: { locale?: string };
	[RoutesPath.RegisterPrivacyNotice]: { locale?: string };
	[RoutesPath.PatientDetails]: { active?: TabPatientDetails; programId?: string };
	[RoutesPath.ProgramBuilder]: { programId?: string; templateId?: string; openScheduleModal?: string };
	[RoutesPath.TemplateBuilder]: { templateId?: string };
	[RoutesPath.InviteYourPt]: { locale?: string };
	[RoutesPath.DemoRequest]: { locale?: string };
	[RoutesPath.Debug]: { menu?: string };
	[RoutesPath.Settings]: { active?: TabSettings };
	[RoutesPath.VipLoginRedirection]: { veevaid?: string };
	[RoutesPath.ForgotPassword]: { lang?: string };
	[RoutesPath.AccountDeleted]: { lang?: string };
	[RoutesPath.ProgramList]: { active?: ProgramListTabNames };
	[RoutesPath.Learn]: Record<string, never>;
};

// The params that are passed using the state and are not visible in the URL
export type StateParams = {
	[RoutesPath.Login]: { email?: string; password?: string; errorMessage?: string };
	[RoutesPath.ForgotPassword]: { email?: string };
	[RoutesPath.Register]: { userAttributes?: RegistrationUserAttributes };
	[RoutesPath.ProgramList]: { newProgramId: string };
	[RoutesPath.AccountDeleted]: { leavingReasons: LeavingReason[] };
	[RoutesPath.Home]: { openAddPatientModal?: boolean };
	[RoutesPath.TemplateBuilder]: { preSelectedExercises?: BaseExercise[] };
};

export enum TabPatientDetails {
	PROGRESS_TAB = "progress",
	PROGRAMS_TAB = "programs",
	HEALTHCARE_TAB = "healthcare",
}
